import TeacherApplications from './TeacherApplications.page';

export default TeacherApplications;